import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@jsverse/transloco';
import { InputDirective, SelectComponent, SelectItemsComponent, SelectOptionComponent } from 'shared/ui-common';

@Component({
  standalone: true,
  imports: [FormsModule, TranslocoModule, MatSelectModule, SelectComponent, SelectItemsComponent, SelectOptionComponent, InputDirective],
  selector: 'tt-interval-input',
  templateUrl: './interval-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./interval-input.component.scss'],
})
export class IntervalInputComponent {
  public _value: number;
  @Input() public set value(value: number) {
    this._value = value;
  }

  public _dateType: string;
  @Input() public set dateType(dateType: string) {
    this._dateType = dateType;
  }

  @Output() public valueChanged = new EventEmitter<number>();
  @Output() public dateTypeChanged = new EventEmitter<string>();

  public onValueChange(newValue: number) {
    this.valueChanged.emit(newValue);
  }

  public onDateTypeChange(newValue: string) {
    this.dateTypeChanged.emit(newValue);
  }
}
